import React from "react";
import PropTypes from "prop-types";

/**
 * @param {Button.propTypes} props
 */
export const Button = (props) => {
	const classes = [
		"py-2 px-8 rounded-sm text-white font-semibold focus:outline-none focus:shadow-none border-0 cursor-pointer",
		"bg-" + props.color,
	].join(" ");

	const onClick = (event) => {
		if (props.isDisabled) {
			event.preventDefault();
			return;
		} else {
			props.onClick();
		}
	};

	// If href prop is present, we need to render a link.
	if (props.href != null) {
		return (
			<a
				href={props.href}
				onClick={onClick}
				rel="noopener noreferrer"
				target="_blank"
				className={[classes, "no-underline hover:text-white"].join(" ")}
			>
				{props.label}
			</a>
		);
	}

	return (
		<button className={classes} onClick={onClick} type={props.type}>
			{props.label}
		</button>
	);
};

Button.defaultProps = {
	type: "button",
	color: "bg-black",
	isDisabled: false,
	onClick: () => {},
};

Button.propTypes = {
	/**
	 * If href is not null, an anchor tag will be rendered.
	 */
	href: PropTypes.string,
	/**
	 * Button color class.
	 * Available options: plugin-1, plugin-2, plugin-3
	 */
	color: PropTypes.string,
	label: PropTypes.string,
	/**
	 * Only applies if not a link.
	 */
	type: PropTypes.string,
	isDisabled: PropTypes.bool,
	onClick: PropTypes.func,
};
